import { render, staticRenderFns } from "./OrderInfoForm.vue?vue&type=template&id=064c70e2&scoped=true"
import script from "./OrderInfoForm.vue?vue&type=script&lang=ts"
export * from "./OrderInfoForm.vue?vue&type=script&lang=ts"
import style0 from "./OrderInfoForm.vue?vue&type=style&index=0&id=064c70e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c70e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064c70e2')) {
      api.createRecord('064c70e2', component.options)
    } else {
      api.reload('064c70e2', component.options)
    }
    module.hot.accept("./OrderInfoForm.vue?vue&type=template&id=064c70e2&scoped=true", function () {
      api.rerender('064c70e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/OrderInfoForm.vue"
export default component.exports